export const customStyles = {
  headRow: {
    style: {
      backgroundColor: "#F2F2F2",
      fontSize: "0.938rem",
      fontWeight: "500",
      color: "#1A2425",
      textAlign: "center",
    },
  },
}